<template>
  <div class="login-container">
    <form @submit.prevent="login">
      <h2>用户登录</h2>
      <div class="form-group">
        <label for="username">用户名</label>
        <input 
          type="text" 
          id="username" 
          v-model="credentials.username" 
          required
          placeholder="请输入用户名或邮箱"
        />
      </div>
      
      <div class="form-group">
        <label for="password">密码</label>
        <input 
          type="password" 
          id="password" 
          v-model="credentials.password" 
          required
          placeholder="请输入密码"
        />
      </div>
      
      <div class="form-group">
        <button type="submit" :disabled="isLoading">
          {{ isLoading ? '登录中...' : '登录' }}
        </button>
      </div>
      
      <div v-if="error" class="error-message">
        {{ error }}
      </div>
      
      <div class="forgot-password-link">
        <router-link to="/forgot-password">忘记密码？</router-link>
      </div>
      
      <div class="register-link">
        没有账号？<router-link to="/register">去注册</router-link>
      </div>
      
      <div class="icp-info">
        <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">
          豫ICP备2025139425号-1
        </a>
      </div>
    </form>
  </div>
</template>

<script>
import api from '@/services/api';

export default {
  name: 'LoginPage', // 修改为多词组件名
  data() {
    return {
      credentials: {
        username: '',
        password: ''
      },
      isLoading: false,
      error: null
    };
  },
  methods: {
    async login() {
      this.isLoading = true;
      this.error = null;
      
      try {
        const response = await api.login(this.credentials);
        console.log('登录成功:', response.data);
        
        // 存储用户信息和token到本地存储
        localStorage.setItem('user', JSON.stringify(response.data.user));
        localStorage.setItem('token', response.data.token);
        
        // 跳转到首页或其他页面
        this.$router.push('/');
      } catch (err) {
        console.error('登录失败:', err);
        this.error = err.response?.data?.message || '登录失败，请检查用户名和密码';
      } finally {
        this.isLoading = false;
      }
    }
  }
};
</script>

<style scoped>
.login-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  padding: 20px;
  box-sizing: border-box;
}

.login-container form {
  background: white;
  padding: 40px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 450px;
}

h2 {
  text-align: center;
  margin-bottom: 30px;
  color: #333;
  font-size: 24px;
  font-weight: 500;
}

.form-group {
  margin-bottom: 20px;
}

label {
  display: block;
  margin-bottom: 5px;
  font-weight: 500;
  color: #555;
  font-size: 14px;
}

input {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 16px;
  transition: border-color 0.3s ease;
  background: white;
  box-sizing: border-box;
}

input:focus {
  outline: none;
  border-color: #007bff;
}

button {
  width: 100%;
  padding: 12px;
  background: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  transition: background-color 0.3s ease;
}

button:hover {
  background: #0056b3;
}

button:disabled {
  background: #6c757d;
  cursor: not-allowed;
}

.error-message {
  color: #dc3545;
  margin-top: 10px;
  padding: 10px;
  background: #f8d7da;
  border: 1px solid #f5c6cb;
  border-radius: 4px;
  font-size: 14px;
}

.forgot-password-link {
  text-align: center;
  margin-top: 15px;
  color: #666;
  font-size: 14px;
}

.forgot-password-link a {
  color: #dc3545;
  text-decoration: none;
}

.forgot-password-link a:hover {
  text-decoration: underline;
}

.register-link {
  text-align: center;
  margin-top: 10px;
  color: #666;
  font-size: 14px;
}

.register-link a {
  color: #007bff;
  text-decoration: none;
}

.register-link a:hover {
  text-decoration: underline;
}

.icp-info {
  text-align: center;
  margin-top: 20px;
  padding-top: 15px;
  border-top: 1px solid #eee;
}

.icp-info a {
  color: #999;
  text-decoration: none;
  font-size: 12px;
  transition: color 0.3s ease;
}

.icp-info a:hover {
  color: #666;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .login-container {
    padding: 20px 15px;
    min-height: 100vh;
    justify-content: center;
  }
  
  .login-container form {
    padding: 40px 25px;
    margin: 0;
    width: 100%;
    max-width: 400px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  }
  
  h2 {
    font-size: 24px;
    margin-bottom: 30px;
  }
  
  input {
    padding: 14px;
    font-size: 16px; /* 防止iOS缩放 */
    border-radius: 8px;
  }
  
  button {
    padding: 14px;
    font-size: 16px;
    border-radius: 8px;
  }
  
  .forgot-password-link, .register-link {
    font-size: 15px;
  }
}

@media (max-width: 480px) {
  .login-container {
    padding: 15px 10px;
  }
  
  .login-container form {
    padding: 30px 20px;
    max-width: none;
    margin: 0 -5px;
  }
  
  h2 {
    font-size: 22px;
    margin-bottom: 25px;
  }
  
  input {
    padding: 12px;
    font-size: 16px;
  }
  
  button {
    padding: 12px;
    font-size: 16px;
  }
  
  .forgot-password-link, .register-link {
    font-size: 14px;
  }
}

/* 触摸设备优化 */
@media (hover: none) and (pointer: coarse) {
  button:hover {
    background: #007bff;
  }
  
  button:active {
    background: #0056b3;
    transform: scale(0.98);
  }
  
  input {
    -webkit-appearance: none;
  }
  
  .forgot-password-link a:hover,
  .register-link a:hover {
    text-decoration: none;
  }
  
  .forgot-password-link a:active {
    color: #a71e2a;
  }
  
  .register-link a:active {
    color: #0056b3;
  }
}
</style>